/**
 * AIFileUploadV2 constants shared across Phase 3 pages.
 * AC-3.3
 *
 * Pure (non-JSX) constants only — keep this file free of component/JSX
 * exports so editing it stays React Fast Refresh-safe for importers like
 * AIFileUploadV2Context. Error copy lives in `errorMessages.ts`.
 */

export const REJECTION_COPY: Record<string, string> = {
  tampering: 'This document appears to have been modified or tampered with.',
  unreadable:
    'We couldn\u2019t read the content of this document. Please try a clearer scan or photo.',
  corrupt:
    'This document appears to be corrupt or incomplete. Please try uploading again.',
  unsupported:
    'This document type isn\u2019t supported. Please upload a PDF, JPG, or PNG.',
};

/**
 * Fallback confidence threshold used when the backend value has not yet
 * been fetched from the summary endpoint.
 *
 * MUST stay in sync with `pipeline/safety.py::CONFIDENCE_THRESHOLD` on the
 * backend. Matches with confidence below this value are presented to the
 * user for manual confirmation before being applied.
 *
 * Never hard-code 0.7 / 0.70 elsewhere in this feature — always import this
 * constant or read `confidenceThreshold` from AIFileUploadV2Context (which
 * is seeded from the backend's `confidence_threshold` field in the summary
 * response).
 */
export const DEFAULT_CONFIDENCE_THRESHOLD = 0.7;
